import { useMemo } from 'react'

import { useAllMyOrdersQuery, UserOrder } from '@shared/generated'

const LIMIT = 10

export function useInfiniteOrders () {
  const { data, loading, fetchMore, refetch } = useAllMyOrdersQuery({
    variables: {
      pager: {
        page: 1,
        limit: LIMIT,
      },
    },
    notifyOnNetworkStatusChange: true,
  })

  const items = useMemo(() => {
    return (data?.allMyOrders?.edges ?? []).filter(
      (item): item is UserOrder => !!item,
    )
  }, [ data ])

  const total = data?.allMyOrders?.pageInfo?.total ?? 0
  const hasMore = items.length < total

  const loadMore = () => {
    if (!hasMore || loading) return

    const nextPage = Math.floor(items.length / LIMIT) + 1

    fetchMore({
      variables: {
        pager: {
          page: nextPage,
          limit: LIMIT,
        },
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult?.allMyOrders?.edges?.length) return prev

        return {
          ...fetchMoreResult,
          allMyOrders: {
            ...fetchMoreResult.allMyOrders,
            edges: [
              ...(prev.allMyOrders?.edges ?? []),
              ...(fetchMoreResult.allMyOrders?.edges ?? []),
            ],
            pageInfo: fetchMoreResult.allMyOrders.pageInfo,
          },
        }
      },
    })
  }

  return { items, loading, hasMore, loadMore, refetch }
}
